import { gql } from "@apollo/client";

export const GET_STATS_BY_OFFER = gql`
  query tripAnalytics(
    $name: Name!
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
  ) {
    property(
      name: $name
      departureDate: { start: $startDate, finish: $endDate }
    ) {
      countryCode
      name
      city
      region
      length
      category
      departureCity
      minimumBasePrice
      averageBasePrice
      maximumBasePrice
    }
  }
`;
